import Validator from "js-object-validation";
import { message } from "../common";

export const videoTutorial = (data) => {
  const validations = {
    videoName: {
      required: true,
    },
    videoDescription: {
      required: true,
    },
    videoLink: {
      required: true,
    },
  };
  // Error messages
  const messages = {
    videoName: {
      required: message.Required.replace(":item", "video name"),
    },
    videoDescription: {
      required: message.Required.replace(":item", "video description"),
    },
    videoLink: {
      required: message.Required.replace(":item", "Video link"),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
